import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import "./ClassesDetailPage.css";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import DefaultPage from "../DefaultPage/DefaultPage";
import config from "../../config";
import useFetch from "../../hooks/useFetch";
import DynamicZoneBuilder from "../../components/DynamicZoneBuilder";

const ClassesDetailPage = () => {
  const params = useParams();
  const { id } = params;

  const { loading, error, data } = useFetch(
    `${config.api}/api/classes/${id}?populate[components][on][bloky.images][populate]=*&populate[components][on][bloky.text][populate]=*`
  );

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání třídy" />;

  if (!data || !data.data)
    return <DefaultPage message="Nepodařilo se získat detail o třídě" />;

  document.title = data?.data?.name;
  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction title={data?.data?.name} />
      <div className="container container-background d-flex flex-column gap-4 p-5">
        <DynamicZoneBuilder components={data?.data?.components} />
      </div>
      <Footer />
    </div>
  );
};
export default ClassesDetailPage;
